import { render } from "./HeroiconsOutlineFolderRemove.vue?vue&type=template&id=c700e976"
const script = {}

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFolderRemove.vue"]])

export default __exports__